module.exports = __webpack_public_path__ + "img/marketing.5b5c1058.png";